import React from "react"
import { FacebookProvider, EmbeddedPost } from "react-facebook"
import styled from "styled-components"

import useSiteMetadata from "../../hooks/use-site-metadata"

const Wrapper = styled.div`
  > div {
    text-align: center;
  }
`

const Facebook = ({ url }) => {
  const { facebookAppId, lang } = useSiteMetadata()
  return (
    <Wrapper>
      <FacebookProvider appId={facebookAppId} language={lang === `it` ? `it_IT` : `en_US`} wait>
        <EmbeddedPost href={url} width="500" />
      </FacebookProvider>
    </Wrapper>
  )
}

export default Facebook
